var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Router, } from '@angular/router';
import { AuthenticationService, } from '@synisys/idm-authentication-client-js';
import { ClassifierService } from '@synisys/idm-classifier-service-client-js';
import { DeService } from '@synisys/idm-de-service-client-js';
import { FormService, FormType } from '@synisys/idm-dynamic-layout-interpreter';
import { LockingService } from '@synisys/idm-lock-service-client-js';
import { Observable } from 'rxjs/Observable';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { catchError, first, map, mapTo, switchMap } from 'rxjs/operators';
import { LockGuard } from '../lock.guard';
import { loadEntityWithNameFieldsOnly } from '../../utils';
import { KbService } from '@synisys/idm-kb-service-client-js';
var OnlineLockGuard = /** @class */ (function (_super) {
    __extends(OnlineLockGuard, _super);
    function OnlineLockGuard(lockService, authenticationService, router, formService, classifierService, deService, kbService) {
        var _this = _super.call(this) || this;
        _this.lockService = lockService;
        _this.authenticationService = authenticationService;
        _this.router = router;
        _this.formService = formService;
        _this.classifierService = classifierService;
        _this.deService = deService;
        _this.kbService = kbService;
        return _this;
    }
    OnlineLockGuard.prototype.canActivate = function (route, state) {
        var systemName = route.params.categoryName;
        var formName = route.params.formName;
        var instanceId = route.params.id;
        var formId = Number(route.params.formId);
        return this.checkForLock(systemName, formName, instanceId, formId);
    };
    OnlineLockGuard.prototype.checkForLock = function (systemName, formName, instanceId, formId) {
        var _this = this;
        var type$ = this.formService.loadFormTypeId(formName, formId, systemName);
        return type$.pipe(switchMap(function (type) {
            if (type === FormType.EDIT && instanceId) {
                return _this.isLocked(systemName, instanceId).pipe(switchMap(function (isLocked) {
                    if (isLocked) {
                        return Observable.of(false);
                    }
                    if (!isLocked && type === FormType.EDIT) {
                        return _this.addLock(systemName, instanceId).pipe(mapTo(true));
                    }
                    return Observable.of(true);
                }));
            }
            return Observable.of(true);
        }), catchError(function (err) {
            console.error(err);
            _this.navigateToLockErrorPage();
            return Observable.of(false);
        }), first());
    };
    OnlineLockGuard.prototype.isLocked = function (systemName, instanceId) {
        var _this = this;
        return combineLatest(this.lockService.getLock(systemName, instanceId), this.lockService.getPermanentLock(systemName, instanceId)).pipe(switchMap(function (_a) {
            var lock = _a[0], permanentLock = _a[1];
            var lockData = lock.getIsLocked()
                ? lock
                : permanentLock.getIsLocked()
                    ? permanentLock
                    : undefined;
            if (lockData) {
                return _this.authenticationService.getUserData().pipe(map(function (userData) {
                    if ((lock.getIsLocked() &&
                        userData.userId !== lock.userId) ||
                        permanentLock.getIsLocked()) {
                        _this.navigateToLockErrorPage(lockData.userFullName);
                        return true;
                    }
                    return false;
                }));
            }
            return Observable.of(false);
        }));
    };
    OnlineLockGuard.prototype.addLock = function (systemName, instanceId) {
        var _this = this;
        return loadEntityWithNameFieldsOnly(this.kbService, this.deService, systemName, instanceId).pipe(switchMap(function (entity) {
            return _this.classifierService.getEntityName(systemName, entity);
        }), switchMap(function (entityName) {
            return _this.lockService.addLock(systemName, instanceId, entityName);
        }));
    };
    OnlineLockGuard.prototype.navigateToLockErrorPage = function (userName) {
        if (userName) {
            this.router.navigateByUrl("dynamic-de/locked;userName=" + userName);
        }
    };
    OnlineLockGuard = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [LockingService,
            AuthenticationService,
            Router,
            FormService,
            ClassifierService,
            DeService,
            KbService])
    ], OnlineLockGuard);
    return OnlineLockGuard;
}(LockGuard));
export { OnlineLockGuard };
//# sourceMappingURL=online-lock.guard.js.map